import Http from './../http';

const prefix = '/website-form';

export const get = (encrypted_id) => Http.authApi().get(`${prefix}/${encrypted_id}`);



// WEBPACK FOOTER //
// ./src/js/services/restrictArea/formTheme.js